<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="340px"
    class="c-mailcheck"
  >
    <p>
      <span v-html="$t('SHARED__MAILCHECK_MSG')"></span>
      <span @click="email = suggestedEmail" class="c-mailcheck__suggestion">
        {{ suggestedEmail }}</span
      >?
    </p>
    <el-input v-model="email"></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">{{
        $t("SHARED__CONFIRM_EMAIL")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ConfirmEmailDialog",
  props: {
    originalEmail: {
      type: String
    },
    suggestedEmail: {
      type: String
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      email: null
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm", this.email)
    },
    handleClose() {
      this.$emit("close")
    }
  },
  watch: {
    originalEmail: {
      handler(val) {
        this.email = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-mailcheck {
  &__suggestion {
    font-family: latobold, HelveticaNeue, "Helvetica Neue", Helvetica, Arial,
      sans-serif;
    cursor: pointer;
  }
}
</style>
